<template>
  <el-container class="container">
    <el-main>
      <div class="box">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="">
              <el-input v-model="formData.code" placeholder="配置ID" clearable :readony="this.parentData.edit_mode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="">
              <el-input v-model="formData.name" placeholder="配置名称" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="flex: 1;overflow: auto">
          <KfJsonEditor style="min-height: 100%" v-model="formData.content" :mode="parentData.editorMode" ></KfJsonEditor>
        </el-row>
        <el-row style="padding-top:20px">
          <div style="text-align: center;width: 100%">
            <el-button @click="saveSchema" style="width: 100px;height: 36px;font-size: 18px">保存</el-button>
            <el-button @click="lockSchema" :disabled="this.parentData.edit_mode == false" style="width: 100px;height: 36px;font-size: 18px">锁定</el-button>
            <el-button @click="unlockSchema" :disabled="this.parentData.edit_mode == false" style="width: 100px;height: 36px;font-size: 18px">解锁</el-button>
            <el-button @click="delSchema" :disabled="this.parentData.edit_mode == false" style="width: 100px;height: 36px;font-size: 18px">删除</el-button>
            <el-button @click="testCompile" style="width: 100px;height: 36px;font-size: 18px">测试编译</el-button>
            <el-button @click="testRun" style="width: 100px;height: 36px;font-size: 18px">测试运行</el-button>
          </div>
        </el-row>
      </div>
    </el-main>
    <el-aside>
      <div ref="msgList" class="msg-list">
        <div v-if="msgList.length==0" class="empty-tip">AI平台构建器</div>
        <div class="msg-item" v-for="item in msgList">
          <div class="icon">
            <el-icon :size="32" v-if="item.role=='assistant'">
              <ElIconCpu/>
            </el-icon>
          </div>
          <div class="content-box" :class="item.role">
            <div v-if="item.role=='assistant'" style="display: flex;justify-content: space-between;color: rgb(60, 60, 67, 60%)">
              <div>
                <span style="margin-right: 30px;">内容由 AI 生成</span>
                <el-button link type="primary" @click="copy(item.content)">复制</el-button>
                <el-button link type="primary" @click="apply(item.content)">应用</el-button>
              </div>
              <div>{{ item.create_user_name }} {{ item.create_time }}</div>

            </div>
            <div class="content">{{ item.content }}</div>
          </div>
          <div class="icon">
            <el-icon :size="32" v-if="item.role=='user'">
              <ElIconUser/>
            </el-icon>
          </div>
        </div>
      </div>
      <div class="send-box">
        <el-input v-model="question" autosize placeholder="请输入问题，按Enter发送，按Ctrl+Enter" type="textarea" @keydown="handleKeyDown"></el-input>
        <el-button @click="sendMsg" round style="margin-left: 4px">发送</el-button>
      </div>
    </el-aside>
  </el-container>
</template>

<script>
import EventSource from 'eventsource';
import {nanoid} from "nanoid";

export default {
  name: "FrameJsonAi1",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      formData: {
        code: '',
        type: this.parentData.type,
        dir_id: this.parentData.dir_id,
        name: '',
        content: ''
      },
      question: '',
      msgList: []
    }
  },
  mounted() {
    if (this.parentData.edit_mode == true) {
      this.loadSchema();
    }
  },
  methods: {
    async copy(content) {
      try {
        await navigator.clipboard.writeText(content);
        this.$message.success('内容已复制到剪贴板')
      } catch (err) {
        this.$message.success('无法复制内容：' + err);
      }
    },
    apply(content) {
      this.formData.content = content
    },
    handleKeyDown(event) {
      if (event.key === 'Enter') {
        if (event.ctrlKey || !this.question || /^\s*$/.test(this.question)) {
          event.preventDefault();
          const start = event.target.selectionStart;
          const end = event.target.selectionEnd;
          this.question = this.question.substring(0, start) + '\n' + this.question.substring(end);
          setTimeout(() => {
            event.target.selectionStart = event.target.selectionEnd = start + 1;
          }, 1)
        } else {
          event.preventDefault();
          this.sendMsg()
        }
      }
    },
    async sendMsg() {
      if (!this.formData.type) {
        this.$message.error('parentData里未传入type参数')
        return;
      }

      if (!this.formData.code) {
        this.$message.error('请先在左侧配置里输入【ID】参数')
        return;
      }

      if (!this.question || /^\s*$/.test(this.question)) {
        this.$message.error('请输入问题内容')
        return;
      }

      let baseUrl = window.location.protocol + '//' + window.location.host + process.env.VUE_APP_AXIOS_BASE_URL;
      let url = baseUrl + `ai/send?token=${localStorage.getItem('token')}&type=${this.formData.type}&id=${this.formData.code}&question=${this.question}`;

      this.msgList.push({
        role: 'user',
        content: this.question
      })
      this.question = ''
      this.scrollToBottom()

      let uuid = nanoid()
      let create_user_name = '';
      let create_time = '';
      const eventSource = new EventSource(url);
      eventSource.onmessage = (event) => {
        let data = event.data;
        if (data.startsWith('data: ')) {
          data = data.substring(6);
          data = data.replace(/\\n/g, '\n')
        } else {
          return;
        }

        if (data.startsWith('[HEAD_DONE]')) {
          let arr = data.substring(11).split(';');
          if (arr.length == 2) {
            create_user_name = arr[0]
            create_time = arr[1]
          }

        } else if (data === '[DONE]') {
          eventSource.close();
          let obj = this.msgList.find(item => item.uuid === uuid);
          if (obj) {
            obj.content = JSON.stringify(JSON.parse(obj.content), null, 2);
          }

        } else {
          let obj = this.msgList.find(item => item.uuid === uuid);
          if (obj) {
            obj.content = obj.content + data;
          } else {
            this.msgList.push({
              uuid: uuid,
              role: 'assistant',
              create_user_name: create_user_name,
              create_time: create_time,
              content: data
            })
          }
        }
        this.scrollToBottom()
      };
      eventSource.onerror = (error) => {
        console.error('Error了', error, '====', eventSource.readyState)
        this.$message.error('请求AI失败。' + error)
        eventSource.close();
      };

      this.scrollToBottom()

    },
    scrollToBottom() {
      this.$nextTick(() => {
        if (this.$refs.msgList) {
          this.$refs.msgList.scrollTop = this.$refs.msgList.scrollHeight;
        }
      });

    },
    async saveSchema() {
      if (!this.formData.type) {
        this.$message.error('parentData里未传入type参数')
        return;
      }

      if (!this.formData.code) {
        this.$message.error('请输入配置ID')
        return;
      }
      if (!this.formData.name) {
        this.$message.error('请输入配置名称')
        return;
      }

      if (!this.formData.content || /^\s*$/.test(this.formData.content)) {
        this.$message.error('请输入配置的内容')
        return;
      }

      try {
        JSON.parse(this.formData.content);
      } catch (e) {
        this.$message.error('配置的JSON内容格式错误')
        return;
      }

      //保存
      if (this.parentData.edit_mode == true) {
        await this.$http('sysSchemaService.edit', this.formData);
      } else {
        await this.$http('sysSchemaService.add', this.formData);
      }


      this.$message.success('保存成功')
    },
    async delSchema() {

      this.$confirm('你确定要删除【' + this.parentData.code + '】吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http('sysSchemaService.del', this.parentData);
        this.$message.success('删除成功')
      });
    },
    async loadSchema() {
      let schemaInfo = await this.$http('sysSchemaService.loadSchema', this.parentData);

      this.formData = schemaInfo.schema;
      this.msgList = schemaInfo.historyList;

    },
    async testCompile() {
      await this.$http('sysSchemaJavaClassService.testCompile', {});
    },
    async testRun() {
      await this.$http('test_ext_service_001.test', this.parentData);
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
}

.el-main {
  border-right: 2px dotted #ddd;

  .box {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}


.el-aside {
  width: 50%;
  display: flex;
  flex-direction: column;

  .empty-tip {
    font-size: 24px;
    color: #ccc;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

}

.send-box {
  display: flex;
  padding: 20px;
}

.msg-list {
  flex: 1;
  overflow: auto;

  .msg-item {
    display: flex;
    padding: 20px 20px 0 20px;

    .icon {
      width: 50px;
      text-align: center;
    }

    .content-box {
      flex: 1;
      white-space: pre-wrap;
      border-bottom: 1px dashed #ccc;
      padding-bottom: 20px;
    }

    .content-box .content {
      border-radius: 15px;
      padding: 10px;
    }

    .content-box.user {
      display: flex;
      justify-content: flex-end;
    }

    .content-box.user .content {
      background-color: AliceBlue;
    }

    .content-box.assistant {

    }

    .content-box.assistant .content {
      background-color: #F4F4F4;
    }

  }

  .msg-item:last-child .content-box {
    border-bottom: none;
  }
}

</style>